/*
 * Copyright (c) 2023 CalAmp Corp. All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../theme/theme';
import {IconSize} from '../types/types';

export type TimeOutlinedIconProps = {
  color?: string;
  size?: IconSize | number;
}
/*
 * Defines the Design Language System (DLS) Time Outlined Icon component.
 */
export const TimeOutlinedIcon = ({color = dlsColor('grey3'), size = 24}: TimeOutlinedIconProps) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.5723 9V12.9771L14.3237 14.9914" stroke={color} strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round"/>
      <circle cx="12" cy="12" r="9" stroke={color} strokeWidth="1.5"/>
    </svg>
  );
};

export default TimeOutlinedIcon;
